import NoDetailsForVerifyStaffIcon from "../../assets/images/NoDetailsForVerifyStaffIcon";
import { OnboardConstants } from "../../constants/constants";
import Button from "./cta/Button";
import { VerifyStaffButton } from "./styles/CommonStyles";

const NoDetailsForVerifyStaffScreen = ({ title,handleAddDetail }: any) => {
  return (
    <div>
      <div className="flex flex-col items-center px-4 ">
        <NoDetailsForVerifyStaffIcon />
        <div className="text-center staffVerifySubTitle pt-2">
          {OnboardConstants.VerifyStaffDetailTitle}
        </div>
        <div className="text-center roleButton pt-1">
          {`${OnboardConstants.VerifyStaffDetailDescription} ${title} details`}
        </div>
        <Button
          handleClick={handleAddDetail}
          buttonText={"Add Details"}
          className={VerifyStaffButton}
        />
      </div>
    </div>
  );
};
export default NoDetailsForVerifyStaffScreen;
